var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'road-card road-card--'+_vm.status},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),(_vm.value!=undefined)?_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]):(_vm.img)?_c('img',{attrs:{"src":_vm.img,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }